import classes from "./ReleaseActivityPage.module.css";
import React, {useState} from "react";
import {
    ACTIVITY_TYPE_PLACEHOLDER, ATTENDANCE,
    EDIT_CONFIGURATION_TEXT,
    INTEGRATION_TYPE_TEXT_PLACEHOLDER, LEARN_MORE_TEXT,
    LMS_TYPE, ONE_MORE_STEP_ACTIVITY, ONE_MORE_STEP_DESCRIPTION_ACTIVITY,
    POLL_TEXT,
    POLL_TYPE,
    VIEW_ALL_ACTIVITIES_TEXT
} from "../../utils/constants";
import YuJaButton from "../../components/standardization/YuJaButton";
import {useHistory, useParams} from "react-router-dom";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import Skeleton from "react-loading-skeleton";
import {useSession} from "../../hooks/useSession";
import {Button} from "@base-ui/react/button";


export default function ViewOneMoreStep({pollData}) {
    const {poll} = pollData;
    const { pollKey, pollCode } = useParams();
    const history = useHistory();
    const {getIntegrationType} = useSynLMSConfiguration();
    const integrationType = getIntegrationType();
    const {parseSessionToken} = useSession();
    const [loading, setLoading] = useState(true);
    const {lmsCourseUrl=""} = parseSessionToken();


    const onClickConfiguration = () => {
        history.push({
            pathname: `/edit/${pollKey}/${pollCode}`,
            state: {
                view: "configuration",
                pollType: poll.pollType,
                isFromOneMoreStep: true,
            }
        });
    }

    const onViewAll = () => {
        history.push("/poll/user/");
    }

    const onClickLearnMore = () => {
        window.open(LMS_TYPE[integrationType].embeddingLearnMore, '_blank');
    }


    return (
        <div className={classes.parentContainer}>
            <div className={classes.mainCard} style={{alignItems: "center", padding: 25}}>
                <span style={{flex: 1}}/>
                <span className={classes.title} style={{fontSize: 20}}>
                    {ONE_MORE_STEP_ACTIVITY.replaceAll(
                        ACTIVITY_TYPE_PLACEHOLDER,
                        poll.pollType === POLL_TYPE.ATTENDANCE
                            ? ATTENDANCE
                            : POLL_TEXT
                    ).replaceAll(
                        INTEGRATION_TYPE_TEXT_PLACEHOLDER,
                        LMS_TYPE[integrationType].name
                    )}
                </span>
                <span className={classes.description}>
                    {ONE_MORE_STEP_DESCRIPTION_ACTIVITY.replaceAll(
                        ACTIVITY_TYPE_PLACEHOLDER,
                        poll.pollType === POLL_TYPE.ATTENDANCE
                            ? ATTENDANCE
                            : POLL_TEXT
                    ).replaceAll(
                        INTEGRATION_TYPE_TEXT_PLACEHOLDER,
                        LMS_TYPE[integrationType].name
                    )}
                    <Button className={classes.link} style={{marginLeft: 5}} onClick={onClickLearnMore}>
                        {LEARN_MORE_TEXT + "."}
                    </Button>
                </span>


                {!!loading &&
                    <div
                        style={{
                            display: "block",
                            width: "min(1000px, 100%)",
                            height: "auto",
                            aspectRatio: "16 / 9", /* modern browsers */
                            border: "none",
                            marginTop: 30,
                        }}
                    >
                        <Skeleton
                            inline={true}
                            borderRadius={4}
                            width={"100%"}
                            height={"100%"}
                        />
                    </div>
                }


                <iframe
                    title={`Tutorial of embedding in ${LMS_TYPE[integrationType].name}.`}
                    allowFullScreen={true}
                    style={{
                        visibility: loading ? "hidden" : "visible",
                        borderRadius: 4,
                        display: "block",
                        width: "min(1000px, 100%)",
                        height: "auto",
                        aspectRatio: "16 / 9", /* modern browsers */
                        border: "none",
                        marginTop: 30,
                    }}
                    onLoad={() => setLoading(false)}
                    onError={(err) => {
                        console.log(err);
                        setLoading(false);
                    }}
                    src={LMS_TYPE[integrationType].embedVideo}
                />



                <div style={{display: "grid", marginTop: 30, gap: 10, gridTemplateColumns: "1fr 1fr 1fr"}}>
                    <YuJaButton
                        type={"secondary"}
                        style={{
                            width: "100%",
                            height: 35,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                        onClick={onClickConfiguration}
                    >
                        {EDIT_CONFIGURATION_TEXT}
                    </YuJaButton>


                    <YuJaButton
                        type={"secondary"}
                        style={{
                            width: "100%",
                            height: 35,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                        onClick={onViewAll}
                    >
                        {VIEW_ALL_ACTIVITIES_TEXT}
                    </YuJaButton>

                    {!!lmsCourseUrl &&
                        <YuJaButton
                            style={{
                                width: "100%",
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            onClick={() => window.open(lmsCourseUrl)}
                        >
                            {`Go to ${LMS_TYPE[integrationType].shortName} Course`}
                        </YuJaButton>
                    }
                </div>
                <span style={{flex: 2}}/>
            </div>
        </div>
    );
}